import { Box } from '@mui/material';
import React from 'react';
import HotspotIcon from './hotspot-icon';
import { getAutoHotspots } from '../../store/car-slice';
import { useSelector } from 'react-redux';
import AutoHotspots from './auto-hotspots';

type PropTypes = {
  carModel: any;
  canvas: any;
  handleClickHotspot: Function;
  currentImageOrder: any;
  canvasLoaded: any;
};

export default function HotspotButton(props: PropTypes) {
  const { carModel, canvas, handleClickHotspot, currentImageOrder } = props;

  const autoHotspots = useSelector(getAutoHotspots);

  const currentImage = carModel?.find(
    (car: any) => car?.order === currentImageOrder,
  );

  // push autohotspot existed in current image frame
  const autoHotspotsInCurrentFrame: any = [];

  autoHotspots.forEach((hotspot) => {
    const hotspotItem = hotspot.positions.find(
      (item: any) => item.frameOrder === currentImageOrder,
    );

    if (hotspotItem) {
      autoHotspotsInCurrentFrame.push({
        x: hotspotItem.x,
        y: hotspotItem.y,
        features: hotspot.features,
        featuresList: hotspot.featuresList,
      });
    }
  });

  const autoHotspotsIcon = autoHotspotsInCurrentFrame?.map(
    (hotspot: any, index: number) => (
      <Box
        key={index}
        sx={{
          position: 'absolute',
          left: hotspot.x + '%',
          top: hotspot.y + '%',
          transition: 'all 0.3s ease-in-out',
        }}
      >
        <AutoHotspots
          data={[hotspot]}
          handleClickHotspot={handleClickHotspot}
        />
      </Box>
    ),
  );

  const normalHotspotIcon = currentImage?.reports?.map((report: any) => {
    const newReport = Array.isArray(report) ? report[0] : report;

    const left = newReport?.x * 100;
    const top = newReport?.y * 100;

    if (canvas?.getBoundingClientRect()?.width > 0) {
      return (
        <Box
          key={report?.id}
          sx={{
            position: 'absolute',
            left: left + '%',
            top: top + '%',
            transition: 'all 0.3s ease-in-out',
          }}
        >
          <HotspotIcon
            handleClickHotspot={handleClickHotspot}
            report={report}
          />
        </Box>
      );
    }
  });

  return (
    <>
      {normalHotspotIcon}
      {autoHotspotsIcon}
    </>
  );
}
